import { render } from "./PersonalInfo.vue?vue&type=template&id=42f78a00"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__